// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__92Dnc","error":"InputSecondary_error__2nlqv","disabled":"InputSecondary_disabled__17BZi"};